import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexGroups',
  setup(__props) {

const ButtonAddons = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/inputgroups/ButtonAddons.vue"))
const CustomForms = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/inputgroups/CustomForms.vue"))
const FileInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/inputgroups/FileInput.vue"))
const ButtonsDropdowns = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/inputgroups/ButtonsDropdowns.vue"))
const SegmentedButtons = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/inputgroups/SegmentedButtons.vue"))
const CheckboxesRadios = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/inputgroups/CheckboxesRadios.vue"))
const SizingInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/inputgroups/SizingInput.vue"))
const MultipleInputs = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/inputgroups/MultipleInputs.vue"))
const BasicInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/inputgroups/BasicInput.vue"))
const VariationAddons = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/inputgroups/VariationAddons.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(ButtonAddons)),
      _createVNode(_unref(CustomForms)),
      _createVNode(_unref(FileInput)),
      _createVNode(_unref(ButtonsDropdowns)),
      _createVNode(_unref(SegmentedButtons)),
      _createVNode(_unref(CheckboxesRadios)),
      _createVNode(_unref(SizingInput)),
      _createVNode(_unref(MultipleInputs)),
      _createVNode(_unref(BasicInput)),
      _createVNode(_unref(VariationAddons))
    ])
  ]))
}
}

})